import { debounce } from '../utils/debounce.js';

export default function () {
  const tabAnchor = document.getElementById('tabAnchor');
  const tabAnchorOptions = document.getElementById('tabAnchorOptions');
  const productPriceCta = document.getElementById('productPriceCta');

  const writeReviewButton = document.querySelector('#product-reviews-write-review');
  const tabAnchorProductReviews = document.querySelector('#tabAnchorSection-product-reviews');

  if (!tabAnchor || !productPriceCta || !tabAnchorOptions) return;

  const links = tabAnchor.querySelectorAll('a');
  const sections = document.querySelectorAll('[data-theme]');

  if (!sections) return;

  let productPriceCtaRect = productPriceCta.getBoundingClientRect();
  let productPricAabsoluteTop = productPriceCtaRect.top + window.scrollY;

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const selector = e.target.getAttribute('href');

      if (!selector) return;

      scrollToWithOffset(selector, -5);

      if (writeReviewButton && e.target === tabAnchorProductReviews) {
        writeReviewButton.click();
      }
    });
  });

  const onResize = debounce(() => {
    productPriceCtaRect = productPriceCta.getBoundingClientRect();
    productPricAabsoluteTop = productPriceCtaRect.top + window.scrollY;
  }, 100);
  window.addEventListener('resize', onResize);

  window.addEventListener('scroll', () => {
    if (window.scrollY >= productPricAabsoluteTop - tabAnchor.clientHeight) {
      tabAnchorOptions.classList.add('show');
    } else {
      tabAnchorOptions.classList.remove('show');
    }

    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();

      if (rect.top < 0 && rect.bottom > 0) {
        tabAnchor.classList.remove('theme-light', 'theme-dark');
        tabAnchor.classList.add(`theme-${section.dataset.theme}`);

        links.forEach((link) => {
          link.classList.remove('is-active');
        });
        links[index].classList.add('is-active');
      }
    });
  });
}

function scrollToWithOffset(selector, offset = 10) {
  const el = document.querySelector(selector);
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({ top: y, behavior: 'smooth' });
}
